export type ReimpositionEligibleLabelParts = {
  contributionNumber: number;
  formattedBalance: string;
};

export function reimpositionEligibleLabel(parts: ReimpositionEligibleLabelParts): string {
  return `Nro ${parts.contributionNumber}–disp.=${parts.formattedBalance}`;
}
